const emortSounds = [
  {
    id: 'clap',
    file: 'clap.mp3',
    emoji: '👏',
    playingDuration: 1000,
    isPlaying: false
  },
  {
    id: 'like',
    file: 'like.mp3',
    emoji: '👍',
    playingDuration: 1000,
    isPlaying: false
  },
  {
    id: 'boo',
    file: 'boo.mp3',
    emoji: '👎',
    playingDuration: 1000,
    isPlaying: false
  },
  {
    id: 'hi',
    file: 'hi.mp3',
    emoji: '✋',
    playingDuration: 1000,
    isPlaying: false
  },
  {
    id: 'ahaha',
    file: 'ahaha.mp3',
    emoji: '😆',
    playingDuration: 1000,
    isPlaying: false
  },
  {
    id: 'warota',
    file: 'warota.mp3',
    emoji: '😂',
    playingDuration: 1000,
    isPlaying: false
  }
]

const msgPopSounds = [
  {
    id: 'normal',
    file: 'normal.mp3',
    playingDuration: 400,
    isPlaying: false
  },
  {
    id: 'thinking',
    file: 'thinking.mp3',
    playingDuration: 400,
    isPlaying: false
  },
  {
    id: 'shout',
    file: 'shout.mp3',
    playingDuration: 400,
    isPlaying: false
  }
]

const doodleSounds = [
  {
    id: 'doodle_created',
    file: 'doodle_created.mp3',
    playingDuration: 400,
    isPlaying: false
  }
]

export { emortSounds, msgPopSounds, doodleSounds }
